import styled from '@emotion/styled';
import { Box, Grid } from '@mui/material';
import { shouldForwardProps } from '../../../utils';

const ProjectsContainer = styled(Box, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.onPrimaryDark};
`;

const ProjectsGrid = styled(Grid, shouldForwardProps)`
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacing(3)};
    margin-left: ${({ theme }) => theme.spacing(3)};
    margin-right: ${({ theme }) => theme.spacing(3)};
    padding: ${({ theme }) => theme.spacing(3)};
`;

export { ProjectsGrid, ProjectsContainer };
